module.exports = __webpack_public_path__ + "img/9788949123080.90c8db36.jpg";